import script from "./SpontaneousConversationPractice.vue?vue&type=script&setup=true&lang=js"
export * from "./SpontaneousConversationPractice.vue?vue&type=script&setup=true&lang=js"

import "./SpontaneousConversationPractice.vue?vue&type=style&index=0&id=900c02f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-900c02f6"]])

export default __exports__